import { Message } from 'element-ui'
import { login, logout, getUserInfo,updatePassword,getMenuByUserId } from 'src/api/user'
import {getToken, setToken, removeToken, getUserId, setUserId, removeUserId, setRoleLevel,removeRoleLevel} from 'src/utils/auth'
import { loopMenu } from 'src/utils'
import { resetRouter } from 'src/router'

import headImg from 'src/assets/user/default_avatar.png'

const state = {
    token: getToken(),
    user_id: getUserId(),
    name:'',
    role_id:-1,
    role:'',
    role_level:-1,
    avatar: '',
    menus: [],
    permission_code: []
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USERID: (state, id) => {
        state.user_id = id
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_ROLE_ID: (state, id) => {
        state.role_id = id
    },
    SET_ROLE: (state, role) => {
        state.role = role
    },
    SET_ROLE_LEVEL: (state, level) => {
        state.role_level = level
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_MENUS: (state, menus) => {
        state.menus = menus
    },
    SET_PERMISSION_CODE: (state, code) => {
        state.permission_code = code
    }
}

const actions = {
    // user login
    login({ commit }, userInfo) {
        const { username, password } = userInfo
        return new Promise((resolve, reject) => {
            login({ username: username.trim(), password: password }).then(response => {
                if(Object.prototype.hasOwnProperty.call(response,'success'))
                {
                    if(response['success'])
                    {
                        const { data } = response

                        if(Object.prototype.hasOwnProperty.call(response,'requestHeaderToken'))
                        {
                            commit('SET_TOKEN', response["requestHeaderToken"])
                            setToken(response["requestHeaderToken"])

                            commit('SET_USERID',data['id'])
                            setUserId(data['id'])

                            commit('SET_NAME',data['username'])
                            commit('SET_ROLE_ID',data['roleId'])
                            commit('SET_ROLE',data['roleName'])
                            commit('SET_ROLE_LEVEL',data['roleLevel'])
                            setRoleLevel(data['roleLevel'])

                            const avatar = headImg
                            commit('SET_AVATAR', avatar)
                        }
                    }
                   else
                    {
                        Message({
                            message: response['errorMsg'],
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                }
                else
                {
                    Message({
                        message: "Login failed",
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getUserInfo({ commit},param) {
        return new Promise((resolve, reject) => {
            getUserInfo(param).then(response => {
                if(Object.prototype.hasOwnProperty.call(response,'success'))
                {
                    if(response['success'])
                    {
                        const { data } = response
                        commit('SET_USERID',data['id'])
                        commit('SET_NAME',data['username'])
                        commit('SET_ROLE_ID',data['roleId'])
                        commit('SET_ROLE',data['roleName'])
                        commit('SET_ROLE_LEVEL',data['roleLevel'])
                        const avatar = headImg
                        commit('SET_AVATAR', avatar)

                    }
                    else
                    {
                        Message({
                            message: response['errorMsg'],
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                }
                else
                {
                    Message({
                        message: "request failed",
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    getUserMenu({ commit},param) {
        return new Promise((resolve, reject) => {
            getMenuByUserId(param).then(response => {
                if(Object.prototype.hasOwnProperty.call(response,'success'))
                {
                    if(response['success'])
                    {
                        const { data } = response
                        // menus must be a non-empty array
                        if (!data || data.length <= 0) {
                            reject('getUserMenu: menus must be a non-null array!')
                        }
                        commit('SET_MENUS', data)

                        const new_arr = []
                        loopMenu(data,new_arr)
                        commit('SET_PERMISSION_CODE', new_arr)
                        resolve(new_arr)
                    }
                    else
                    {
                        Message({
                            message: response['errorMsg'],
                            type: 'error',
                            duration: 5 * 1000
                        })
                        resolve()
                    }
                }
                else
                {
                    Message({
                        message: "request failed",
                        type: 'error',
                        duration: 5 * 1000
                    })
                    resolve()
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    updatePassword({ commit},userInfo) {
        return new Promise((resolve, reject) => {
            updatePassword(userInfo).then(response => {
                if(Object.prototype.hasOwnProperty.call(response,'success'))
                {
                    if(response['success'])
                    {
                        Message({
                            message: response['errorMsg'],
                            type: 'success',
                            duration: 5 * 1000
                        })
                        resolve(true)
                    }
                    else
                    {
                        Message({
                            message: response['errorMsg'],
                            type: 'error',
                            duration: 5 * 1000
                        })
                        resolve(false)
                    }
                }
                else
                {
                    Message({
                        message: "request failed",
                        type: 'error',
                        duration: 5 * 1000
                    })
                    resolve(false)
                }

            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                commit('SET_TOKEN', '')
                commit('SET_MENUS', [])
                commit('SET_USERID',-1)
                commit('SET_PERMISSION_CODE', [])
                removeToken()
                resetRouter()
                removeUserId()
                removeRoleLevel()
                // reset visited views and cached views
                // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
                dispatch('tagsView/delAllViews', null, { root: true })

                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_MENUS', [])
            commit('SET_USERID',-1)
            commit('SET_PERMISSION_CODE', [])
            removeToken()
            removeUserId()
            removeRoleLevel()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
